import { Badge } from "@krea/shared/design-system/Badge";
import { ResponsiveTooltip } from "@krea/shared/design-system/ResponsiveTooltip";

import type { LenderApplicationTypeEnum } from "@/features/common/enums";

import {
  getStatusTextAndDescriptionByType,
  getVariantByLenderApplicationType,
} from "../../utils";

export const StatusLabel = ({
  type,
  hasActiveLenderResponses,
  hideTooltip,
}: {
  type?: LenderApplicationTypeEnum;
  hasActiveLenderResponses?: boolean;
  hideTooltip?: boolean;
}) => {
  const variant = getVariantByLenderApplicationType(type);
  const status = getStatusTextAndDescriptionByType(
    type,
    hasActiveLenderResponses,
  );

  return (
    status && (
      <dl className="mx-0 my-1 flex flex-wrap items-center">
        <dt className="mr-2 font-semibold">Status:</dt>
        <dd className="text-[1.25rem] font-normal">
          <ResponsiveTooltip
            hidden={hideTooltip}
            trigger={<Badge variant={variant}>{status.label}</Badge>}
          >
            {status.description}
          </ResponsiveTooltip>
        </dd>
      </dl>
    )
  );
};
